import React from 'react'

import styled from '@emotion/styled'
import {
  Box,
  FlexDirection,
  AlignItems,
  Color,
  Display3,
  Heading4,
  JustifyContent,
  Text,
} from '@gousto-internal/citrus-react'

const StrikethroughCredit = styled(Text)`
  text-decoration: line-through;
`

interface Props {
  supercededCredit?: string
  credit: string
}

export const CreditBlob: React.FC<Props> = ({ supercededCredit, credit }) => (
  <Box
    display="flex"
    flexDirection={FlexDirection.Column}
    bg={Color.Primary_600}
    alignItems={AlignItems.Center}
    justifyContent={JustifyContent.Center}
    borderRadius="round"
    paddingV={4}
    paddingH={4}
    height={['96px', '96px', '120px', '120px']}
    width={['96px', '96px', '120px', '120px']}
  >
    {supercededCredit ? (
      <Box display="flex" flexDirection={FlexDirection.Row} alignItems={AlignItems.Baseline}>
        <StrikethroughCredit
          color={Color.White}
          size={[4, 4, 8, 8]}
          data-testid="strikethrough-credit"
        >
          {supercededCredit}
        </StrikethroughCredit>
        <Display3 size={[9, 9, 12, 12]} color={Color.White}>
          {credit}
        </Display3>
      </Box>
    ) : (
      <Display3 size={[9, 9, 13, 13]} color={Color.White}>
        {credit}
      </Display3>
    )}
    <Heading4 color={Color.White}>credit</Heading4>
  </Box>
)
